/**
 * Types for criteria builder schemas
 */

export type OperatorType = 'eq' | 'gt' | 'gte' | 'lt' | 'lte' | 'contains' | 'between';

export interface FieldOption {
  value: string;
  label: string;
}

export interface FieldDefinition {
  path: string;
  label: string;
  type: 'string' | 'number' | 'array' | 'date' | 'boolean';
  operators: OperatorType[];
  options?: FieldOption[] | 'dynamic'; // 'dynamic' means load from API
  description?: string;
  placeholder?: string;
}

export interface CategoryDefinition {
  name: string;
  description?: string;
  fields: FieldDefinition[];
}

export interface EntitySchema {
  entityType: string;
  displayName: string;
  description?: string;
  categories: CategoryDefinition[];
}

// Operator display labels
export const OPERATOR_LABELS: Record<OperatorType, string> = {
  eq: 'equals (=)',
  gt: 'greater than (>)',
  gte: 'greater than or equal (>=)',
  lt: 'less than (<)',
  lte: 'less than or equal (<=)',
  contains: 'contains',
  between: 'between',
};

// Operator DSL symbols
export const OPERATOR_DSL: Record<OperatorType, string> = {
  eq: '=',
  gt: '>',
  gte: '>=',
  lt: '<',
  lte: '<=',
  contains: 'CONTAINS',
  between: 'BETWEEN',
};
